import DemoCTA from '../DemoCTA.jsx';
import { isPlaceholder } from '../../data/products.js';
import TheoLogo from '../TheoLogo.jsx';
import OpenChartsLogo from '../OpenChartsLogo.jsx';

function CTAMark({ product, height }) {
  if (product.id === 'theo') return <TheoLogo height={height} />;
  if (product.id === 'charts') return <OpenChartsLogo height={height} />;
  return null;
}

export default function ProductCTABand({ product }) {
  const showPresentation = !isPlaceholder(product.presentationLink);
  const hasMark = product.id === 'theo' || product.id === 'charts';
  return (
    <div className="product-cta-band">
      <div className="product-cta-band__copy">
        {hasMark ? (
          <strong style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            See <CTAMark product={product} height={22} /> in action.
          </strong>
        ) : (
          <strong>See {product.name} in action.</strong>
        )}
        <span>Walk through {product.name} live with a senior solutions architect.</span>
      </div>
      <div className="product-cta-band__actions">
        {showPresentation && (
          <a
            className="btn-ghost"
            href={product.presentationLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            View product →
          </a>
        )}
        <DemoCTA variant="primary" source={product.id} label={product.ctaLabel} />
      </div>
    </div>
  );
}
